import type { ReactNode } from "react";

export type BadgeTone = "neutral" | "good" | "warn" | "bad" | "highlight";

const TONE_CLASSES: Record<BadgeTone, string> = {
  neutral: "bg-ink-100 text-ink-700",
  good: "bg-emerald-100 text-emerald-800",
  warn: "bg-amber-100 text-amber-800",
  bad: "bg-rose-100 text-rose-800",
  highlight: "bg-pitch-700 text-white",
};

export type BadgeProps = {
  children: ReactNode;
  tone?: BadgeTone;
  title?: string;
  className?: string;
};

/**
 * Small chip-style label. Used for league IDs, margin status, +EV markers.
 * Plain element (not focusable) — pair with `Stat` when a tooltip is needed.
 */
export function Badge({ children, tone = "neutral", title, className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${TONE_CLASSES[tone]} ${className}`}
      title={title}
    >
      {children}
    </span>
  );
}
